import React, { Component } from "react";
import { DND_LINK } from "../../../utils/constants";
 
//import CheckBoxContainer from "../../../common/CheckboxContainer/CheckboxContainer";
 
class ShowMoreDropdown extends Component{
    constructor(props) {
      super(props);
      this.state = {
        listOpen: this.props.isOpen
      };
    }

    
    renderColumnNames = () => {
      return (
        <div className="col-md-12">
            
        <a 
					onClick={() => {
            this.props.toggleNotesModal(this.props.selectedServiceForKnowMore);			    
					}}
			     >
				   {" "}Add Notes{" "}
			  </a>

            <br></br>


            {
              
							this.props.selectedServiceForKnowMore.refCurrentState&& this.props.selectedServiceForKnowMore.refCurrentState.sServiceState=="Delivered"?
							(
								<>
									<a href="javascript:void(0);" onClick={(e) => this.props.toggleShowFeedbackModal(e, this.props.selectedServiceForKnowMore)} target="_self" className="conv-color">
									{"Feedback"}
                  
									</a>
                  
								</>								
							):
              
							(
   
                <>
                <a className={`conv-color ${this.props.selectedServiceForKnowMore.refCurrentState&& this.props.selectedServiceForKnowMore.refCurrentState.sServiceState!="Delivered"?"disable":""}`} href="javascript:void(0);" onClick={(e) => this.props.toggleShowFeedbackModal(e, this.props.selectedServiceForKnowMore)} target="_self">
                {"Feedback"}
                </a>
              </>				
                
							)
						}

            {/* <a 
					onClick={() => {
            this.props.toggleShowFeedbackModal(this.props.selectedServiceForKnowMore);			    
					}}
			     >
				   {" "}Feedback{" "}
			  </a> */}

            <br></br>

            <a className="con-cursor-pointer"
              onClick={() => { localStorage.setItem("Number", this.props.sContactNumber) }}
              href="/home/three-sixty-degree-view-new/" target="_blank">
              
             <span className="conv-color">
                 360 Degree View
             </span>
            </a>

            <br></br>

            <span>
            <a href={DND_LINK} target="_blank">
            DND Update Link
            </a>
            </span>

            {/* <br></br>
            {
              this.props.selectedServiceForKnowMore.sServiceCode==="LTEXP" 
              || this.props.selectedServiceForKnowMore.sServiceCode==="LTEXPCOACH" 
              || this.props.selectedServiceForKnowMore.sServiceCode==="EXPRTCONSULT" 
              || this.props.selectedServiceForKnowMore.sServiceCode==="GRPEXPRTCONSULT"
              ?
              <a className="con-cursor-pointer"
            href="/home/admin-expert-calendar/" target="_blank">
              
             <span className="conv-color">
                 Expert Calendar
             </span>
            </a>
            : 
            <a className="con-cursor-pointer"
            href="/home/admin-expert-calendar/" target="_blank" style={{
              pointerEvents: "none",
              opacity:"0.4"
            }}>
              
             <span className="conv-color">
                 Expert Calendar
             </span>
            </a>

            } */}


        </div>
      );
    };
  
    render() {
      const { listOpen } = this.state;
      return (
        <div>           
          {listOpen && (              
            <div className="divFloatingsColumnsDropdown">
                <div className="row">
                   {this.renderColumnNames()}
                </div>
            </div>
          )}
        </div>
      );
    }
  }
  
  export default ShowMoreDropdown;